<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate text-truncate">Configuraciones de usuarios</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Usuarios', route: '/user' }, { label: 'Configuraciones de usuarios' }]" />
    </div>
  </section>

  <section wrapper>
    <p-accordion [value]="['0', '1', '2']" [multiple]="true">
      <p-accordion-panel value="0" class="mb-2">
        <p-accordion-header>
          <div class="d-flex flex-row justify-content-between align-items-center gap-2 w-100 pe-3">
            <h6 class="m-0">Desactivar módulos a varios usuarios.</h6>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <app-disable-multiple-modules />
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel value="1" class="mb-2">
        <p-accordion-header>
          <div class="d-flex flex-row justify-content-between align-items-center gap-2 w-100 pe-3">
            <h6 class="m-0">Grupos de precios.</h6>

            <div class="d-flex flex-row justify-content-between align-items-center gap-2">
              <p-button label="Crear nuevo grupo" size="small" (click)="openDrawerCreatePricingGroupStatus($event)" />
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <app-pricing-group [(createDrawerVisible)]="drawerCreatePricingGroupStatus" />
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel value="2" class="mb-2">
        <p-accordion-header>
          <div class="d-flex flex-row justify-content-between align-items-center gap-2 w-100 pe-3">
            <h6 class="m-0">Grupos de bancos.</h6>

            <div class="d-flex flex-row justify-content-between align-items-center gap-2">
              <p-button label="Crear nuevo grupo" size="small" (click)="openDrawerCreateBankGroupStatus($event)" />
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <app-bank-group [(createDrawerVisible)]="drawerCreateBankGroupStatus" />
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </section>
</backbone>
